import type { BoxProps } from '@montugroup/design-system';
import { Stack, Typography } from '@montugroup/design-system';
import { Fade, useTheme } from '@mui/material';
import {
  StyledHeadingBoxMobile,
  StyledImageContainerInner,
  StyledImageContainerOuter,
  StyledImg,
} from './StepsCarouselStyles';

type StepsCarouselImagesProps = {
  title: React.ReactNode;
  subtitle: string;
  stepImages: string[];
  activeStep: number;
};

export type StyledStepContainerProps = BoxProps & {
  activeStep: boolean;
};

export function StepsCarouselImages({ title, subtitle, stepImages, activeStep }: StepsCarouselImagesProps) {
  const theme = useTheme();
  return (
    <Stack
      direction="column"
      alignItems="flex-start"
      spacing={{ xs: 10, lg: 0 }}
      width={{ xs: '100%', md: '55%', lg: theme.spacing(142) }}
    >
      <StyledHeadingBoxMobile>
        <Typography variant="h4" fontSize={30} fontWeight={600}>
          {title}
        </Typography>
        <Typography variant="subtitle1">{subtitle}</Typography>
      </StyledHeadingBoxMobile>
      <StyledImageContainerOuter>
        <StyledImageContainerInner>
          {stepImages.map((stepImage, index) => (
            <Fade key={`step-image-${index}`} in={activeStep === index} timeout={1000}>
              <StyledImg src={stepImage} />
            </Fade>
          ))}
        </StyledImageContainerInner>
      </StyledImageContainerOuter>
    </Stack>
  );
}
